import Vue from 'vue';
// 自定义指令长按触发回调函数
Vue.directive('longpress', {
  bind: function (el, binding, vNode) {
    if (typeof binding.value.callback !== 'function') {
      throw 'callback must be a function'
    }
    // 定义变量
    let pressTimer = null
    // 创建计时器（ 2秒后执行函数 ）
    let start = (e) => {
      if (e.type === 'click' && e.button !== 0) {
        return
      }
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          handler(binding.value.params)
        }, 500)
      }
    }
    // 取消计时器
    let cancel = (e) => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer)
        pressTimer = null
      }
    }
    // 运行函数
    const handler = (e,params) => {
      binding.value.callback(e, params); // 传递item参数
    };
    // 添加事件监听器
    el.addEventListener('mousedown', start)
    el.addEventListener('touchstart', start)//在移动端要考虑 touchstart，touchend 事件
    // 取消计时器
    el.addEventListener('click', cancel)
    el.addEventListener('mouseout', cancel)
    el.addEventListener('touchend', cancel)//在移动端要考虑 touchstart，touchend 事件
    el.addEventListener('touchcancel', cancel)//在移动端要考虑 touchstart，touchend 事件
  },
  // 当传进来的值更新的时候触发
  componentUpdated(el, {value}) {
    el.$value = value
  },
  // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    el.removeEventListener('click', el.handler)
  },
})


// WEBPACK FOOTER //
// ./src/directives/index.js